import React, { useEffect, useState } from 'react'
import { BiErrorAlt } from 'react-icons/bi';
import Cart from './Cart';

export default function OrderFailSummary() {
    const [successData, setSuccessData] = useState([])

    // const tranId ="e36a2bfe-af18-4a0f-86b3-33f67d591764";
    useEffect(() => {
        window.scrollTo(0, 0)
  
    }, [])



    return (
        <div className='bg-gray-200'>
            <div className='container mx-auto  sm:p-0 md:p-5'>
                <div className='bg-white grid grid-cols-5 pt-5 p-4'>
                    <div className='md:col-span-2 col-span-5'>
                        <div className='bg-gray-50 mt-3 p-3'>
                            <div className="mark-icon text-center">
                                <div className='w-full flex justify-center'>
                                    <BiErrorAlt className='text-4xl font-bold text-red-600' />
                                </div>
                                <h3 className='text-2xl font-normal text-gray-600 mb-3'>Sorry !!! Your payment has failed</h3>
                                <p className='t text-gray-600'>We are very sorry. If you encounter this same problem more than once, please contact us.</p>
                            </div>
                            <div className='p-4'>
                                {
                                    successData.map((item) => (
                                        <ul className="list-disc">
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Order Id : <span className='font-semibold'>{item?._id}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Date : <span className='font-semibold'>{item?.PlacedDate}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Email : <span className='font-semibold'>{item?.contactInfo.email}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Total : <span className='font-semibold'>{item?.totalPrice} BDT</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Payment : <span className='font-semibold'>{item?.paidStatus}</span></li>
                                        </ul>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className='grid md:col-span-3 col-span-5  mt-3 p-3'>
                        <h3 className='text-2xl font-poppins text-gray-500 pb-3 mb-2 border-b'>Order Details</h3>
                        <Cart orderSmr={true} /> 
                    
                    </div>
                </div>
            </div>
        </div>
    );
}
